import { z } from 'zod';
import { intSchema, moneySchema, optionalText, paginationQuerySchema, requiredText } from './common';

/** Entrada de mercadoria (compra). */
export const stockPurchaseSchema = z.object({
  quantity: intSchema('Quantidade', 1, 1_000_000),
  /** Custo unitário desta compra. */
  unitCost: moneySchema.optional(),
  /** Quando true (e com custo informado), atualiza o preço de custo cadastrado do item. */
  updateCost: z.boolean().optional(),
  note: optionalText(300, 'Observação'),
});
export type StockPurchaseInput = z.infer<typeof stockPurchaseSchema>;
export type StockPurchaseFormValues = z.input<typeof stockPurchaseSchema>;

/** Entrada em lote: vários itens (produtos e/ou componentes) de uma mesma compra. */
export const stockBatchSchema = z.object({
  supplier: optionalText(120, 'Fornecedor'),
  invoice: optionalText(40, 'Nota fiscal'),
  /** Data da compra (AAAA-MM-DD); entra apenas na observação das movimentações. */
  receivedAt: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Data inválida.')
    .optional()
    .nullable(),
  items: z
    .array(
      z.object({
        kind: z.enum(['product', 'component']),
        id: z.string().uuid('Item inválido.'),
        quantity: intSchema('Quantidade', 1, 1_000_000),
        unitCost: moneySchema.optional(),
        updateCost: z.boolean().optional(),
      }),
    )
    .min(1, 'Adicione pelo menos um item.')
    .max(100, 'No máximo 100 itens por entrada.'),
});
export type StockBatchInput = z.infer<typeof stockBatchSchema>;

/** Contagem / ajuste: informa a quantidade real encontrada. */
export const stockAdjustSchema = z.object({
  newQuantity: intSchema('Quantidade', 0, 1_000_000),
  note: requiredText(300, 'Motivo do ajuste', 3),
});
export type StockAdjustInput = z.infer<typeof stockAdjustSchema>;
export type StockAdjustFormValues = z.input<typeof stockAdjustSchema>;

export const stockMovementsQuerySchema = paginationQuerySchema.extend({
  pageSize: z.coerce.number().int().min(1).max(100).default(30),
});
